import { render, staticRenderFns } from "./CustomerUpdateDialogNotes.vue?vue&type=template&id=670dc73b&scoped=true"
import script from "./CustomerUpdateDialogNotes.vue?vue&type=script&lang=ts"
export * from "./CustomerUpdateDialogNotes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670dc73b",
  null
  
)

export default component.exports